<template>
    <pp-modal v-model="showModal" :closable="clos" :mask-closable="false" width="488">
        <p slot="header" class="modalHead">
            <span>{{modalheader}}</span>
        </p>
        <div class="modalContent">
            <p>{{modalcontent}}</p>
        </div>
         <div slot="footer">
            <pp-button type="ghost" size="spec" @click="cancle"> {{$t('webList.addWebDialog.cancel')}}</pp-button>
            <pp-button type="primary" size="spec" :loading="loading2"  @click="confirm">{{$t('webList.tradeDetail.cancelPayment')}}</pp-button>
        </div>
    </pp-modal>
</template>

<script>
    import {
        Component,
        Vue,
        Prop,
        Watch
    } from 'vue-property-decorator'
    import {
        createNamespacedHelpers
        } from 'vuex'
        import {
            Getter,
            Action,
            namespace
        } from 'vuex-class'
        const {
            mapGetters: webMapGetters,
            mapActions: webMapActions
        } = createNamespacedHelpers('website')
    export default {
        name: 'cancleModal',
        props: {
            modalcontent: "",
            modalheader: "",
            params:"",
        },
        computed:{
            ...webMapGetters(['cancleTradeRes']),
        },
        mounted() {
            
        },
        data() {
            return {
                showModal: false,
                loading2:false,
                clos:true,
            }
        },
        methods: {
            ...webMapActions([
                'cancleTrade', // 获取交易详情
            ]),
            show() {
                this.showModal = true
            },
            cancle() {
                this.showModal = false
            },
            // 获取初始化交易记录数据
            async confirm(){
                this.clos = false;
                let params ={
                    transactionId : this.params.transactionId,
                    accId : this.params.accId,
                    clientId : this.params.clientId,
                    flowId : this.params.flowId,
                    type:'ACI',
                }
                this.loading2 = true;
                await this.cancleTrade(params)
                setTimeout(() => {
                    this.loading2 = false;
                    this.clos = true;
                  
                    if(this.cancleTradeRes=="提交成功" || this.cancleTradeRes=="SUCCESS"){
                        this.$message.success(this.$t('webList.addWebDialog.cancelStatus'))
                        this.$emit('finish');
                    }
                    this.showModal = false
                }, 3000);
                
                
                
            },
        }
    }
</script>

<style lang="scss" scoped>
    .modalHead {
        color: #000;
        font-size: 20px;
        text-align: left
    }
    
    .modalContent {
        text-align: left;
        font-size: 14px;
    }
</style>
